import {
  ErrorBoundary as SentryErrorBoundary,
  init as SentryInit,
} from "@sentry/react";
import "handsontable/dist/handsontable.full.min.css";
import { registerAllModules } from "handsontable/registry";
import React, { useEffect, useState, Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { hotjar } from "react-hotjar";
import "./index.css";

import { GenericErrorFallback } from "./components/error/generic-error.tsx";
import { InitLoader } from "./components/loaders/InitLoader.tsx";
import { CacheKey, cacheUtil } from "./utils/localstorage.ts";
import { keysToCamel } from "./utils/snakeCaseConverter.ts";

registerAllModules();
/*
if (process.env.NODE_ENV === "development") {
  worker
    .start({
      onUnhandledRequest: "bypass",
    })
    .catch((err) => {
      console.log(err);
    });
}
*/

if (import.meta.env.VITE_HOTJAR_ENABLED === "true") {
  hotjar.initialize({
    id: parseInt(import.meta.env.VITE_HOTJAR_ID as string, 10),
    sv: parseInt(import.meta.env.VITE_HOTJAR_VERSION as string, 10),
  });
}

SentryInit({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: process.env.NODE_ENV === "production",
  // integrations: [
  //   new BrowserTracing({
  //     routingInstrumentation: reactRouterV6Instrumentation(
  //       React.useEffect,
  //       useLocation,
  //       useNavigationType,
  //       createRoutesFromChildren,
  //       matchRoutes
  //     ),
  //   }),
  // ],
  normalizeDepth: 11,
  // Performance Monitoring
  tracesSampleRate: 0.2,
});
const domain = window.location.hostname;

const ORG_ASSETS_URL = `${
  import.meta.env.VITE_ORG_CONFIG_URL
}/static-assets/organisation/config.json?domain=${domain}`;

const MainWrapper = lazy(() => import("./main-wrapper.tsx"));

const Root = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch(ORG_ASSETS_URL, {
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch org assets");
        return res.json();
      })
      .then((_orgAssets) => {
        cacheUtil.set(CacheKey.OrgAssets, keysToCamel(_orgAssets));
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message as string);
        setLoading(false);
      });
  }, []);

  if (loading) return <InitLoader />;
  if (error) return <GenericErrorFallback />;
  const faviconUrl =
    import.meta.env.VITE_ORG_CONFIG_URL +
    "/static-assets/organisation/favicon.svg?domain=" +
    domain;
  console.log(faviconUrl);
  return (
    <React.StrictMode>
      <HelmetProvider>
        <Helmet>
          <link rel="icon" type="image/svg+xml" href={faviconUrl} />
        </Helmet>
        <SentryErrorBoundary fallback={GenericErrorFallback}>
          <Suspense fallback={<InitLoader />}>
            <MainWrapper />
          </Suspense>
        </SentryErrorBoundary>
      </HelmetProvider>
    </React.StrictMode>
  );
};

export const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<Root />);
